import script from "./HeaderRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderRoute.vue?vue&type=script&setup=true&lang=js"

import "./HeaderRoute.vue?vue&type=style&index=0&id=e80fb1f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e80fb1f8"]])

export default __exports__